import React from 'react';

export default function NewUserQuestionHeader({ header, subheader }) {
    return (
        <div style={{ marginBottom: 32 }}>
            <div style={{ fontWeight: 500, fontSize: 28, lineHeight: '36px', letterSpacing: '-0.6px', textAlign: 'center', marginBottom: 4 }}>{header}</div>
            {!!subheader && <div style={{ fontWeight: 400, fontSize: 14, color: 'var(--neutral-700)', lineHeight: '22px', letterSpacing: '-0.13px', textAlign: 'center' }}>{subheader}</div>}
        </div>
    )
}